import { Col, Form, Label, Row } from "reactstrap"
import {
  DebounceInputSearch,
  UFDate,
  UFInput,
} from "../../../components/Common/Fields/Input"
import resetIcon from "../../../assets/icons/reset.svg"
import { useForm } from "react-hook-form"
import { useEffect } from "react"
import moment from "moment"
import { isEmpty } from "lodash"
import AccountsLi from "../../../components/Common/chooseFields/accountsLi"
import FinanceLedgersLi from "../../../components/Common/chooseFields/ledgers"
import { useLocation, useNavigate } from "react-router-dom"
import LoadingButton from "../../../components/Common/LoadingButton"
import { useDispatch } from "react-redux"
import { removeFilter } from "../../../store/actions"

const JournalEntryFilter = ({
  // handleSearchChange,
  handleDateChange,
  handleAccChange,
  initialLedger,
  initialDate,
  resetData,
}) => {
  const { accData, dateFrom, dateTo } = resetData || {}
  const { control, watch, reset, setValue } = useForm()
  const navigate = useNavigate()
  const location = useLocation()
  console.log(`location?.pathname`, location?.pathname, location)

  const dispatch = useDispatch()

  const handleReset = () => {
    navigate(
      location?.pathname == "/finance-ledger-acc"
        ? "/finance-ledger-acc"
        : "/finance-account-book"
    )
    handleDateChange()
    // handleSearchChange()
    handleAccChange()
    reset({
      search: "",
      ledger_id: null,
    })
  }
  // useEffect(() => {
  //   handleSearchChange(watch("search"))
  // }, [watch("search")])

  console.log("initialleder", initialDate)

  useEffect(() => {
    if (initialLedger != null) {
      reset({
        ledger_id: initialLedger || null,
        start_date: initialDate ? initialDate[0] : null,
        end_date: initialDate ? initialDate[1] : null,
      })
      // handleDataUpdate
    }
    // handleDataUpdate()
  }, [initialLedger, initialDate])

  // const handleRequestdate = data => {
  //   let fromDate = ""
  //   let toDate = ""
  //   fromDate = !isEmpty(data) ? moment(data[0]).format("YYYY-MM-DD") : ""
  //   toDate = !isEmpty(data) ? moment(data[1]).format("YYYY-MM-DD") : ""
  //   //  reset({
  //   //   ...getValues(),
  //   //   req_date: data
  //   // });
  //   handleDateChange(fromDate, toDate)
  // }

  const handleRequestdate = () => {
    const statDate = watch("start_date")
    const enDate = watch("end_date")
    const fromDate = statDate ? moment(statDate).format("YYYY-MM-DD") : ""
    const toDate = enDate ? moment(enDate).format("YYYY-MM-DD") : ""
    handleDateChange(fromDate, toDate)
  }

  useEffect(() => {
    setValue(
      "ledger_id",
      accData ? { label: accData.label, value: accData.value } : null,
      { shouldValidate: false, shouldDirty: false }
    )
    setValue(
      "start_date",
      dateFrom ? moment(dateFrom, "YYYY-MM-DD").toDate() : null,
      { shouldValidate: false, shouldDirty: false }
    )
    setValue(
      "end_date",
      dateTo ? moment(dateTo, "YYYY-MM-DD").toDate() : null,
      { shouldValidate: false, shouldDirty: false }
    )
  }, [dateFrom, dateTo, accData, setValue])

  const handleAccno = async data => {
    // reset({
    //   ...getValues(),
    //   ledger_id: data || null,
    // })
    await dispatch(removeFilter())

    handleAccChange(data)
    //    handleDatas({
    //     ...getValues(),
    //     ledger_id: data || null,
    //   })
    // }
    // const handleDataUpdate = () => {
    //   const dataValues = getValues()
    //   handleDatas(dataValues)
  }
  return (
    <>
      <div className="d-flex justify-content-between align-items-center my-2 me-2 py-3">
        <Form id="user-form" className="filter-wrapper">
          <Row className="mx-0">
            <Col sm={3} className="pe-1">
              <FinanceLedgersLi
                control={control}
                placeholder="select"
                name={"ledger_id"}
                target={"body"}
                groupId={
                  location?.pathname == "/finance/sundry-debtors"
                    ? 13
                    : location?.pathname == "/finance/account-payable"
                    ? 34
                    : ""
                }
                onSelectChange={e => handleAccno(e)}
                // onSelectChange={e => handleAccno(e)}
              />
              {/* <AccountsLi
                control={control}
                name={"account_code"}
                placeholder={"Code"}
                target={"body"}
                fromFilter={true}
              /> */}
            </Col>
            <Col sm={3} className="pe-1">
              <UFDate
                control={control}
                name={"start_date"}
                placeholder={"Start Date"}
                onDateChange={handleRequestdate}
              />
            </Col>
            <Col sm={3} className="pe-1">
              <UFDate
                control={control}
                name={"end_date"}
                placeholder={"End Date"}
                onDateChange={handleRequestdate}
              />
            </Col>
          </Row>
        </Form>
        <div className="d-flex ">
          <div
            className="export-div pointer me-2 ms-0 reset-img py-1"
            onClick={() => handleReset()}
          >
            <img src={resetIcon} height={15} width={15} className="me-2" />{" "}
            Reset
          </div>
        </div>
      </div>
    </>
  )
}

export default JournalEntryFilter
